'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var paths = require('./paths.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const NarvarLogo = _ref => {
  let {
    style = {}
  } = _ref;
  const {
    color: iconFill = '#999999'
  } = style || {};
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    style: {
      width: '9.5625rem',
      height: '1.5625rem',
      paddingTop: '0.375rem',
      fill: iconFill,
      ...style
    },
    viewBox: "0 0 153 24"
  }, /*#__PURE__*/React__default["default"].createElement("title", null, "Powered by Narvar"), /*#__PURE__*/React__default["default"].createElement("path", {
    d: paths.poweredByNarvarString
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: paths.isotype
  }));
};

exports["default"] = NarvarLogo;
